import { render, staticRenderFns } from "./veStuAssocActivityApplyEdit.vue?vue&type=template&id=6fc243ed&scoped=true"
import script from "./veStuAssocActivityApplyEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityApplyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc243ed",
  null
  
)

export default component.exports